"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoSearchResults = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Error_module_css_1 = tslib_1.__importDefault(require("./Error.module.css"));

var Parameters_1 = require("../Control/Parameters");

exports.NoSearchResults = function (_a) {
  var _b;

  var view = _a.view;
  var searchErrorClassName = classnames_1.default((_b = {}, _b[Error_module_css_1.default.pad] = true, _b[Error_module_css_1.default.searchModal] = view === Parameters_1.CertificatesListView.Modal, _b));
  return react_1.default.createElement("div", {
    className: searchErrorClassName
  }, react_1.default.createElement("div", {
    className: Error_module_css_1.default.caption
  }, "\u041C\u044B \u043D\u0435 \u043D\u0430\u0448\u043B\u0438 \u0442\u0430\u043A\u043E\u0433\u043E \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430"), react_1.default.createElement("div", {
    className: Error_module_css_1.default.text
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0439 \u0437\u0430\u043F\u0440\u043E\u0441"));
};